import React from 'react';
import { Copy, Button, Squish } from '@grubhubprod/gh-cookbook-react';
import { SearchStatus } from 'src/utilities/useSearchHooks';

interface ApplySelectedItemsProps {
  searchStatus: SearchStatus;
  handleApplyClick: () => void;
  disabled?: boolean;
}

export function ApplySelectedItems({
  searchStatus,
  handleApplyClick,
  disabled,
}: ApplySelectedItemsProps): JSX.Element {
  return (
    <Squish inset="md" dimension="3">
      <Button
        variant="primary"
        buttonSize="medium"
        block
        onClick={handleApplyClick}
        disabled={
          disabled ||
          searchStatus === SearchStatus.LOADING ||
          searchStatus === SearchStatus.IDLE
        }
      >
        <Copy variant="body" color="globals.white">
          Apply
        </Copy>
      </Button>
    </Squish>
  );
}
